import { GET_LIST_PENILAIAN, GET_LIST_QUESTIONS, GET_LIST_QUESTIONS_MASTER, GET_DASHBOARD_ME, GET_LIST_REPORT_PROSES, GET_LIST_REPORT_REKAP, GET_DASHBOARD_ADMIN, GET_DETAIL_PENILAIAN, GET_LIST_HISTORI_GENERATE, GET_LIST_PROGRES_EXPORT, GET_OPTION_ROLE, GET_OPTION_PEGAWAI_360, GET_OPTION_ROLE_PENILAI, GET_LIST_ROLE_AKSES, GET_LIST_RELATIONS, GET_DETAIL_RELATION, RESET_DETAIL_RELATION, GET_DETAIL_REPORT_PROSES, GET_LIST_QUARTER, GET_DETAIL_QUARTER, GET_LIST_REPORT_PROSES_PIMPINAN, GET_OPTION_ASSESSMENT, GET_LIST_PEGAWAI_BY_STATUS_PENILAIAN, RESET_LIST_PEGAWAI_BY_STATUS_PENILAIAN } from "shared/constants/ActionTypes";

const INIT_STATE = {
    data: {
        results: [],
    },
    questions: {
        result: null,
    },
    questionsMaster: {
        results: [],
    },
    dashboard: {
        admin: {
            result: null
        },
        me: {
            result: null
        },
        listRekap: {
            results: []
        },
        listProses: {
            results: []
        },
        detailProses: {
            result: {}
        },
        listProsesPimpinan: {
            results: []
        },
        listPegawaiByStatus: {
            results: []
        }
    },
    detail: {
        result: null
    },
    histori: {
        results: []
    },
    listExport: {
        results: []
    },
    roleOption: {
        result: []
    },
    pegawaiOption: {
        result: []
    },
    roleAkses: {
        list: {
            results: []
        }
    },
    relations: {
        list: {
            results: [],
        },
        detail: {
            result: null
        }
    },
    rolePenilaiOption: {
        result: []
    },
    quarter: {
        list: {
            result: []
        },
        detail: {
            result: {}
        }
    },
    assessmentOption: {
        result: []
    },
};

const umpanBalik360Reducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PENILAIAN: {
            return {
                ...state,
                data: action.payload,
            }
        }
        case GET_LIST_QUESTIONS: {
            return {
                ...state,
                questions: action.payload,
            }
        }
        case GET_LIST_QUESTIONS_MASTER: {
            return {
                ...state,
                questionsMaster: action.payload,
            }
        }
        case GET_DASHBOARD_ME: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    me: action.payload
                }
            }
        }
        case GET_DASHBOARD_ADMIN: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    admin: action.payload
                }
            }
        }
        case GET_LIST_REPORT_PROSES: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    listProses: action.payload
                }
            }
        }
        case GET_DETAIL_REPORT_PROSES: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    detailProses: action.payload
                }
            }
        }
        case GET_LIST_REPORT_REKAP: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    listRekap: action.payload
                }
            }
        }
        case GET_DETAIL_PENILAIAN: {
            return {
                ...state,
                detail: action.payload
            }
        }
        case GET_LIST_HISTORI_GENERATE: {
            return {
                ...state,
                histori: action.payload
            }
        }
        case GET_LIST_PROGRES_EXPORT: {
            return {
                ...state,
                listExport: action.payload
            }
        }
        case GET_OPTION_ROLE: {
            const tmpOptions = action.payload.result && action.payload.result.map((item) => ({ id: item.name, label: item.name }))
            return {
                ...state,
                roleOption: {
                    result: tmpOptions
                }
            }
        }
        case GET_OPTION_PEGAWAI_360: {
            const tmpOptions = action.payload.result && action.payload.result.map((item) => ({ id: item.nip, label: item.label, ...item }))
            return {
                ...state,
                pegawaiOption: {
                    result: tmpOptions
                }
            }
        }
        case GET_OPTION_ROLE_PENILAI: {
            const tmpOptions = action.payload.result && action.payload.result.map((item) => ({ id: item.name, label: item.name }))
            return {
                ...state,
                rolePenilaiOption: {
                    result: tmpOptions
                }
            }
        }
        case GET_LIST_ROLE_AKSES: {
            return {
                ...state,
                roleAkses: {
                    ...state.roleAkses,
                    list: action.payload
                }
            }
        }
        case GET_LIST_RELATIONS: {
            return {
                ...state,
                relations: {
                    ...state.relations,
                    list: action.payload
                }
            }
        }
        case GET_DETAIL_RELATION: {
            return {
                ...state,
                relations: {
                    ...state.relations,
                    detail: action.payload
                }
            }
        }
        case RESET_DETAIL_RELATION: {
            return {
                ...state,
                relations: {
                    ...state.relations,
                    detail: {
                        result: null
                    }
                }
            }
        }
        case GET_LIST_QUARTER: {
            return {
                ...state,
                quarter: {
                    ...state.quarter,
                    list: action.payload
                }
            }
        }
        case GET_DETAIL_QUARTER: {
            return {
                ...state,
                quarter: {
                    ...state.quarter,
                    detail: action.payload
                }
            }
        }
        case GET_LIST_REPORT_PROSES_PIMPINAN: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    listProsesPimpinan: action.payload
                }
            }
        }
        case GET_OPTION_ASSESSMENT: {
            const tmpOptions = action.payload.result && action.payload.result.map((item) => ({ id: item.id, label: item.nama }))
            return {
                ...state,
                assessmentOption: {
                    result: tmpOptions
                }
            }
        }
        case GET_LIST_PEGAWAI_BY_STATUS_PENILAIAN: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    listPegawaiByStatus: action.payload
                }
            }
        }
        case RESET_LIST_PEGAWAI_BY_STATUS_PENILAIAN: {
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    listPegawaiByStatus: {
                        results: []
                    }
                }
            }
        }
        default:
            return state;
    }
};
export default umpanBalik360Reducer;
